export const languages = [
    {
        name: "ar",
        key: "ar",
        icon: "/icons/arabic.png",
    },
    {
        name: "en",
        key: "en",
        icon: "/icons/english.png",
    },


];